export default function SectionAbout() {
  return (
    <section id="about" className="py-14 md:py-20 px-4 md:px-6 bg-background-100" style={{ scrollMarginTop: '64px' }}>
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-3">
            关于我们
          </span>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-2">关于被窝网电影</h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">了解被窝网电影的品牌故事与使命</p>
        </div>

        <div className="max-w-3xl mx-auto bg-background-50 rounded-2xl p-8 md:p-10 border border-background-200/70">
          <div className="prose prose-sm max-w-none">
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
              被窝网电影成立于2020年，是一家专注于<strong>电视剧全集免费高清在线观看</strong>的内容聚合平台。我们的使命是让每一位剧迷都能在被窝里舒舒服服地追剧——<strong>不缓冲、不收费、不等待</strong>。
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
              平台目前已收录超过<strong>3000部</strong>热门电视剧，涵盖国产剧、韩剧、美剧、日剧、泰剧、英剧等全品类资源，每日更新最新剧集内容。无论是经典老剧还是热播新剧，在被窝网电影都能找到高清全集。
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
              我们坚持<strong>免费追剧</strong>的理念，不设会员门槛，不强制充值，所有电视剧资源均可免费在线观看。同时持续优化播放技术，确保高清画质下依然流畅不缓冲，为剧迷提供最佳的追剧体验。
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
              被窝网电影——<strong>你温暖的追剧港湾</strong>。躺在床上，打开被窝网电影，开启你的追剧时光。
            </p>
          </div>
          <div className="grid grid-cols-3 gap-4 mt-8 pt-6 border-t border-background-200/70">
            <div className="text-center">
              <div className="font-heading text-2xl text-primary-600">2020年</div>
              <div className="text-xs text-foreground-400 mt-1">平台创立</div>
            </div>
            <div className="text-center">
              <div className="font-heading text-2xl text-accent-600">3000+</div>
              <div className="text-xs text-foreground-400 mt-1">收录剧集</div>
            </div>
            <div className="text-center">
              <div className="font-heading text-2xl text-secondary-600">500万+</div>
              <div className="text-xs text-foreground-400 mt-1">月活剧迷</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}